<h2 mat-dialog-title id="shared-billing-invitation-title" tabindex="-1">Shared billing invitation</h2>
<mat-dialog-content>
    @if (owner.value(); as profile) {
    <div class="mb-4 flex items-center gap-4">
        <img class="h-10 w-10 rounded-full" [src]="profile.photoUrl?.value" alt="" />
        <p class="m-0"><strong>{{profile.displayName}}</strong> has invited you to use their shared billing account.</p>
    </div>
    } @else {
    <p>You have been invited to join a shared billing account.</p>
    }
    <p id="shared-billing-invitation-description">If you accept, your usage will be billed to the shared billing owner's account.</p>
    @if (error()) {
    <p role="alert">{{error()}}</p>
    }
    @if (busy()) {
    <div class="flex items-center gap-2" role="status">
        <mat-progress-spinner mode="indeterminate" [diameter]="20" aria-label="Processing invitation" />
        <span>Updating your shared billing membership...</span>
    </div>
    }
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button matButton type="button" [disabled]="busy()" mat-dialog-close="dismissed">{{accepted() ? 'Close' : 'Not now'}}</button>
    <button matButton type="button" [disabled]="busy() || accepted()" (click)="respond('decline')">Decline</button>
    <button matButton="filled" type="button" [disabled]="busy()" (click)="respond('accept')">
        {{accepted() ? 'Retry account refresh' : 'Accept'}}
    </button>
</mat-dialog-actions>
